module.exports = {"id":"198196","name":"Pierre-Michel Lasogga","rating":"73","photo":"./data/images/photos/4/198196.png","club":{"name":"Leeds Utd","logo":"./data/images/clubs/LeedsUtd.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Pierre-MichelLasogga0.json
// module id = 3461
// module chunks = 0